import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "store/auth/userSlice";
import UpdateEmailDialog from "views/auth/Otp/components/UpdateEmailDialog";
import { isValidEmail } from "utils/isValidEmail";

/**
 * Oturum açıkken e-posta geçerli formatta değilse (ör. telefon kayıtlı) tüm uygulama üzerinde
 * UpdateEmailDialog gösterir; güncelleme sonrası Redux user güncellenir.
 */
function RequireValidEmailGate({ children }) {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth?.session?.token);
  const signedIn = useSelector((state) => state.auth?.session?.signedIn);
  const user = useSelector((state) => state.auth?.user);

  const needsFix = signedIn && Boolean(token) && !isValidEmail(user?.email);

  if (!needsFix) {
    return children;
  }

  return (
    <>
      {children}
      <UpdateEmailDialog
        isOpen
        hideCancel
        onClose={() => {}}
        persistedToken={token}
        onSuccess={(payload) => {
          const email = payload?.data?.email;
          if (email) {
            dispatch(setUser({ ...(user || {}), email }));
          }
        }}
      />
    </>
  );
}

export default RequireValidEmailGate;
